export default __webpack_public_path__ + "static/media/agenda.c55aa518.svg";